module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_06.e17272f0.png";